import React, { useEffect, useState } from "react";
import * as echarts from "echarts";
import { isEmpty, isNil } from "ramda";

const AreaChart = ({
  prefix,
  data,
  measureName,
  withToolbox = true,
  startZoom = 0,
  endZoom = 100,
  pointsSelectHandler = () => {},
  resetZoomHandler = () => {},
  intl,
}) => {
  const [initialZoom, setInitialZoom] = useState();
  const [finalZoom, setFinalZoom] = useState();
  useEffect(() => setInitialZoom(startZoom), [startZoom]);
  useEffect(() => setFinalZoom(endZoom), [endZoom]);

  useEffect(() => {
    const chartElement = document.getElementById(`${prefix}-stacked-line-chart`);
    const myChart = echarts.init(chartElement);

    const options = {
      tooltip: {
        trigger: "axis",
        position: (pt) => [pt?.[0], "10%"],
      },
      legend: {
        data: data?.legend,
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: withToolbox
        ? {
            feature: {
              dataZoom: {
                yAxisIndex: "none",
                title: {
                  zoom: intl.formatMessage({ id: "Zoom in" }),
                  back: intl.formatMessage({ id: "Zoom out" }),
                },
              },
              restore: {
                title: intl.formatMessage({ id: "Restore zoom" }),
              },
              saveAsImage: {
                title: intl.formatMessage({ id: "Save as image" }),
              },
              myCustomCSVDownload: {
                show: true,
                title: intl.formatMessage({ id: "Download CSV" }),
                icon: "image://csv-icon80.png",
                onclick: function () {
                  downloadCSV();
                },
              },
            },
          }
        : {},
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: data?.xAxis?.data,
      },
      yAxis: {
        type: "value",
      },
      series: data?.series?.map((s) => ({
        ...s,
        type: "line",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
        },
        emphasis: {
          focus: "series",
        },
      })),
      dataZoom: [
        {
          type: "inside",
          start: initialZoom,
          end: finalZoom,
        },
        {
          start: initialZoom,
          end: finalZoom,
        },
      ],
    };

    myChart.setOption(options);
    myChart.on("click", onChartClick);
    myChart.on("dataZoom", (params) => onDataZoom(params, data.series[0].data.length));
    myChart.on("restore", () => {
      setInitialZoom(0);
      setFinalZoom(100);
      resetZoomHandler();
    });

    return () => {
      myChart.dispose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, prefix, initialZoom, finalZoom]);

  const onChartClick = (params) => {
    if (params.componentType === "series") {
      const dataIndex = params.dataIndex;
      pointsSelectHandler(dataIndex, dataIndex);
    }
  };

  const onDataZoom = (params, length) => {
    if (
      !isNil(params?.batch) &&
      !isEmpty(params.batch.length) &&
      !isNil(params.batch?.[0]?.startValue) &&
      !isNil(params.batch?.[0]?.endValue)
    ) {
      const startIndex = params.batch[0].startValue;
      const endIndex = params.batch[0].endValue;
      pointsSelectHandler(startIndex, endIndex);
    } /*else if (!isNil(params?.start) && !isNil(params.end)) { // quité esto para que no haga pedidos de temporal cuando 
      const startIndex = parseInt((params.start * length) / 100);
      const endIndex = parseInt((params.end * length) / 100);
      pointsSelectHandler(startIndex, endIndex);
    }*/
  };

  function downloadCSV() {
    const header = ["PK", intl.formatMessage({ id: measureName })].join(",");
    const dateTime = data?.series?.[0]?.name?.replace(" ", "T");
    const pkData = data?.xAxis.data;
    const serialData = data?.series?.[0]?.data;
    const combinedData = pkData.map((pk, index) => [pk, serialData[index]]);

    const csvData = [header].concat(combinedData.map((row) => row.join(","))).join("\n");

    const blob = new Blob([csvData], { type: "text/csv" });

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${dateTime}_${measureName}.csv`;

    a.click();

    URL.revokeObjectURL(a.href);
  }
  return <div id={`${prefix}-stacked-line-chart`} style={{ width: "90%", height: "300px" }} />;
};

export default AreaChart;
